import { Provider as DesignSystemProvider } from '@sortlist-frontend/design-system';
import { ErrorPage as SharedErrorPage } from '@sortlist-frontend/shared-components';
import { Router, useRouter } from 'next/router';

import { PageSeoTag } from '_components/SEO';
import { PublicAppContextProvider } from '_core/context/public-app-context';

type Props = {
  message?: string;
  locale?: string;
};

export const Public404Page = (props: Props) => {
  const { message, locale = 'en' } = props;
  const router = useRouter();

  return (
    <PublicAppContextProvider canonical="" origin="" locale={locale}>
      <PageSeoTag canonical="" nextSeoProps={{ noindex: true, nofollow: true }} />
      <DesignSystemProvider navigate={router.push as Router['push']} className="h-full" locale={locale}>
        <SharedErrorPage statusCode={404} message={message} />
      </DesignSystemProvider>
    </PublicAppContextProvider>
  );
};
